import { styled } from '@mui/material';
import { Eyeglasses, Stethoscope, Tooth } from '@phosphor-icons/react';

export const BenefitsCardStyled = styled('div')({
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.24)',
});

export const BenefitCategoriesWrapperStyled = styled('div')({
  padding: '40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '40px',
  '@media (max-width: 743px)': {
    padding: '24px',
  },
});

export const FormattedPlanYearStyled = styled('p')({
  fontSize: '16px',
  '@media (max-width: 743px)': {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const NoEnrolledBenefitsBoxStyled = styled('div')({
  marginTop: '15rem',
  width: '100%',
  height: '100%',
});

export const NoBenefitsIconBoxStyled = styled('div')<{
  bkgImg: string;
}>(({ bkgImg }) => ({
  backgroundImage: `url(${bkgImg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  width: '125px',
  height: '110px',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
}));

const iconStyle = { 
  color: '#3C548E',
  fontWeight: '600',
 };

export const StethoscopeIconStyled = styled(Stethoscope)(iconStyle);
export const ToothIconStyled = styled(Tooth)(iconStyle);
export const EyeglassesIconStyled = styled(Eyeglasses)(iconStyle);
